<template>
  <v-container class="pa-0" fluid>
    <div v-if="!isMobile" class="home temp-screen">
      <v-img
        max-width="40%"
        class="mx-auto"
        contain
        src="../assets/img/logo.svg"
      ></v-img>
      <h1 class="home-subtitle text-center">
        Ábrelo en tu móvil, nos estamos preparando para que puedas pedir en tu
        computadora.
      </h1>
    </div>

    <v-dialog persistent max-width="70%" v-model="alertDialog">
      <v-card class="rounded-card">
        <v-card-title class="dialog-title red--text">
          Adevertencia!
        </v-card-title>
        <v-card-text class="dialog-text pb-2">
          Añade por lo menos un producto a tu orden
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="my-button mx-auto mb-2"
            :color="company.color"
            block
            dark
            @click="alertDialog = false"
            >Ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent max-width="75%" v-model="confirmDialog">
      <v-card class="rounded-card">
        <v-card-title class="dialog-title mb-5">
          ¿Quieres confirmar tu orden?
        </v-card-title>
        <v-card-text>
          <table class="product-table">
            <tr v-for="item in order" :key="item.id">
              <td>
                <h4 class="item-title">{{ item.name + " $" + item.price }}</h4>
              </td>
              <td>
                <p class="item-title ma-0">
                  {{ item.quantity }}
                </p>
              </td>
            </tr>
          </table>
          <v-divider class="my-5" />
          <h5 class="item-title mb-2">
            {{ "Productos totales: " + totalItems }}
          </h5>
          <h5 class="item-title mb-5">
            {{ "Precio total de tu orden: $" + total + " MXN" }}
          </h5>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="my-button mx-auto px-10 mb-2"
            color="#fff"
            @click="confirmDialog = false"
            >No</v-btn
          >
          <v-btn
            class="my-button mx-auto px-10 mb-2"
            :color="company.color"
            dark
            @click="sendOrder"
            >Si</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="isMobile"
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card class="dialog-card" tile>
        <v-img
          max-height="26vh"
          contain
          class="pedido-banner ma-5"
          src="../assets/img/pedido-banner.png"
        />

        <p class="my-title px-5">
          Mi Orden <span class="oblique-text">powered by Rel Menú</span>
        </p>

        <table class="product-table px-5">
          <tr v-for="item in order" :key="item.id">
            <td>
              <h4 class="item-title">{{ item.name }}</h4>
              <p class="item-description ma-0">{{ item.description }}</p>
              <h4 class="item-price">{{ "$" + item.price }}</h4>
              <v-btn
                class="delete-button"
                @click="quit(item)"
                color="#F73B58"
                small
                dark
                block
              >
                Eliminar producto(s)
              </v-btn>
            </td>
            <td>
              <v-row class="add-btn-container" align="center">
                <v-col cols="5">
                  <p class="cuantity-widget ma-0">
                    {{ item.quantity }}
                  </p>
                </v-col>
                <v-col cols="5">
                  <v-btn
                    class="add-button"
                    @click="add(item)"
                    color="#50C983"
                    small
                    dark
                  >
                    <v-img src="../assets/img/add-icon.svg" />
                  </v-btn>
                </v-col>
              </v-row>
            </td>
          </tr>
        </table>

        <v-divider class="mx-5 my-5" />
        <h5 class="item-title mx-5">{{ "Orden a: " + company.name }}</h5>
        <h5 class="item-title mx-5 mb-2">
          {{ "Productos totales: " + totalItems }}
        </h5>
        <p class="order-terms mx-5 mb-0">
          *La suma del precio total de los productos no contempla los costos de
          envío a domicilio ni los costos extras que pueda generar la orden.
        </p>
        <v-divider class="mx-5 my-5" />
        <h5 class="item-title mx-5 mb-16">
          {{ "Precio total de tu orden: $" + total + " MXN" }}
        </h5>

        <div class="button-container mb-3">
          <v-row align="center" justify="space-around">
            <v-btn @click="dialog = false" class="my-button" color="#fff">
              Ver menú
              <v-img class="ml-2" src="../assets/img/menu-b.svg" />
            </v-btn>
            <v-btn
              class="my-button"
              @click="total > 0 ? (confirmDialog = true) : (alertDialog = true)"
              :color="company.color"
              dark
            >
              Confirmar mi orden
              <v-img class="ml-2" src="../assets/img/wp-icon.svg" />
            </v-btn>
          </v-row>
        </div>
      </v-card>
    </v-dialog>

    <v-img
      src="../assets/img/screen-404.png"
      height="100vh"
      cover
      v-if="isMobile && error404"
      class="px-5"
    >
      <v-row style="height: 100vh" class="text-center">
        <v-col align-self="start" cols="12">
          <v-img
            class="mx-auto mt-5"
            width="30%"
            contain
            src="../assets/img/purple-logo.svg"
          />
          <h1 class="title-404 mt-10">
            Oops! Parece que alguien se ha comido este menú :(
          </h1>
          <p class="text-404 mt-5">
            Pero no te preocupes, la damos una segunda oportunidad a tu hambre.
          </p>
        </v-col>
        <v-col align-self="end" class="pb-10" cols="12">
          <v-btn class="button-404" to="/" color="#FF2266" dark block>
            Ver otros menús disponibles
          </v-btn>
        </v-col>
      </v-row>
    </v-img>

    <v-btn v-if="isMobile && company.isActive" to="/" class="home-button" icon>
      <v-img height="40" contain src="../assets/img/home.svg"></v-img>
    </v-btn>

    <v-card
      v-if="isMobile && company.isActive"
      class="total-card text-center px-3 py-1"
    >
      <p :style="{ color: company.color }" class="ma-0">
        {{ "$ " + total + " MXN" }}
      </p>
    </v-card>

    <v-img
      v-if="isMobile && company.isActive"
      gradient="to bottom, rgba(000,000,000,.0),  rgba(000,000,000, .0), rgba(000,000,000, .5)"
      :src="company.img"
      cover
      class="profile-img"
      height="60vh"
    >
      <div class="header-container">
        <h1 v-if="!company.isDark" class="my-title mb-2">
          {{ company.name }}
        </h1>
        <p v-if="!company.isDark" class="header-text mb-0">
          {{ company.type }}
        </p>
        <p v-if="!company.isDark" class="header-text mb-0">
          {{ company.address }}
        </p>

        <h1 v-if="company.isDark" class="my-title white--text mb-2">
          {{ company.name }}
        </h1>
        <p v-if="company.isDark" class="header-text white--text mb-0">
          {{ company.type }}
        </p>
        <p v-if="company.isDark" class="header-text white--text mb-0">
          {{ company.address }}
        </p>
      </div>
    </v-img>

    <v-container v-if="isMobile && company.isActive" class="px-5">
      <div class="delivery-container">
        <div class="delivery-options">
          <v-row class="py-2">
            <v-col cols="4">
              <v-img
                v-if="company.delivery"
                height="1.3rem"
                contain
                src="../assets/img/delivery.svg"
              />
              <v-img
                v-if="!company.delivery"
                height="1.3rem"
                contain
                src="../assets/img/delivery-light.svg"
              />
              <p class="delivery-text mt-2 mb-0">Entregas a domicilio</p>
            </v-col>
            <v-divider vertical />
            <v-col cols="4">
              <v-img
                v-if="company.onPlace"
                height="1.3rem"
                contain
                src="../assets/img/shop.svg"
              />
              <v-img
                v-if="!company.onPlace"
                height="1.3rem"
                contain
                src="../assets/img/shop-light.svg"
              />
              <p class="delivery-text mt-2 mb-0">Comer en establecimeinto</p>
            </v-col>
            <v-divider vertical />
            <v-col cols="4">
              <v-img
                v-if="company.toGo"
                height="1.3rem"
                contain
                src="../assets/img/car.svg"
              />
              <v-img
                v-if="!company.toGo"
                height="1.3rem"
                contain
                src="../assets/img/car-light.svg"
              />
              <p class="delivery-text mt-2 mb-0">Ordene y recoja</p>
            </v-col>
          </v-row>
        </div>
      </div>

      <p class="my-title">
        Menu <span class="oblique-text">powered by Rel Menú</span>
      </p>
      <table class="product-table mb-16">
        <tr v-for="item in company.menu" :key="item.id">
          <td>
            <h4 class="item-title">{{ item.name }}</h4>
            <p class="item-description ma-0">{{ item.description }}</p>
            <h4 class="item-price">{{ "$" + item.price }}</h4>
          </td>
          <td>
            <v-row class="add-btn-container" align="center">
              <v-col cols="5">
                <p class="cuantity-widget ma-0">
                  {{ item.quantity }}
                </p>
              </v-col>
              <v-col cols="5">
                <v-btn
                  class="add-button"
                  @click="add(item)"
                  color="#50C983"
                  small
                  dark
                >
                  <v-img src="../assets/img/add-icon.svg" />
                </v-btn>
              </v-col>
            </v-row>
          </td>
        </tr>
      </table>

      <div class="button-container mb-3">
        <v-row align="center" justify="space-around">
          <v-btn @click="openOrder" class="my-button" color="#fff">
            Ver orden
            <v-img class="ml-2" src="../assets/img/packet.svg" />
          </v-btn>
          <v-btn
            class="my-button"
            @click="total > 0 ? (confirmDialog = true) : (alertDialog = true)"
            :color="company.color"
            dark
          >
            Confirmar mi orden
            <v-img class="ml-2" src="../assets/img/wp-icon.svg" />
          </v-btn>
        </v-row>
      </div>
    </v-container>
  </v-container>
</template>

<script>
import { db } from "../firebase";

export default {
  data: () => ({
    company: {},
    order: [],
    dialog: false,
    alertDialog: false,
    confirmDialog: false,
    error404: false,
  }),

  created() {
    this.getCompany().then(() => {
      if (this.company && this.company.isActive) {
        this.error404 = false;
      } else {
        this.error404 = true;
      }
    });
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    companyId() {
      return this.$route.params.companyId;
    },
    total() {
      var total = 0.0;
      this.order.forEach((item) => {
        total += item.quantity * item.price;
      });
      return parseFloat(total);
    },
    totalItems() {
      var total = 0.0;
      this.order.forEach((item) => {
        total += item.quantity;
      });
      return parseFloat(total);
    },
  },

  methods: {
    async getCompany() {
      try {
        var menu = [];

        await db
          .collection("companies")
          .doc(this.companyId)
          .collection("menu")
          .orderBy("name")
          .get()
          .then((res) => {
            res.forEach((body) => {
              menu.push({
                id: body.id,
                name: body.data().name,
                description: body.data().description,
                price: body.data().price,
                quantity: 0,
              });
            });
          });

        await db
          .collection("companies")
          .doc(this.companyId)
          .get()
          .then((res) => {
            this.company = {
              name: res.data().name,
              type: res.data().type,
              img: res.data().img,
              phone: res.data().phone,
              address: res.data().address,
              menu: menu,
              color: res.data().color,
              delivery: res.data().delivery,
              onPlace: res.data().onPlace,
              toGo: res.data().toGo,
              isDark: res.data().isDark,
              isActive: res.data().isActive,
            };
          });
      } catch (error) {
        console.log(error);
      }
    },
    add(item) {
      const search = this.order.find((x) => x.id == item.id);
      const search2 = this.company.menu.find((x) => x.id == item.id);
      if (search) {
        this.order[this.order.indexOf(search)].quantity += 1;
        this.company.menu[this.company.menu.indexOf(search2)].quantity += 1;
      } else {
        this.order.push({
          id: item.id,
          name: item.name,
          description: item.description,
          price: item.price,
          quantity: 1,
        });
        const search2 = this.company.menu.find((x) => x.id == item.id);
        this.company.menu[this.company.menu.indexOf(search2)].quantity += 1;
      }
    },
    quit(item) {
      const search = this.order.find((x) => x.id == item.id);
      const indexOrder = this.order.indexOf(search);

      const search2 = this.company.menu.find((x) => x.id == item.id);
      const indexMenu = this.company.menu.indexOf(search2);

      if (search) {
        if (this.order[indexOrder].quantity > 0) {
          this.order[indexOrder].quantity -= 1;
        }
        if (this.order[indexOrder].quantity == 0) {
          this.order.splice(indexOrder, 1);
        }
        this.company.menu[indexMenu].quantity =
          this.company.menu[indexMenu].quantity > 0
            ? (this.company.menu[indexMenu].quantity -= 1)
            : 0;
      }
    },
    openOrder() {
      this.total > 0 ? (this.dialog = true) : (this.alertDialog = true);
    },
    async saveOrder() {
      var today = new Date();
      var date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      var time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var dateTime = date + " " + time;

      await db.collection("orders").add({
        date: dateTime,
        total: this.total,
        order: this.order,
        companyId: this.companyId,
      });
    },
    resetOrder() {
      this.order = [];
      this.getCompany();
      this.dialog = false;
    },
    sendOrder() {
      if (this.total > 0) {
        var url =
          "https://api.whatsapp.com/send?phone=" +
          this.company.phone +
          "&text= *Hola, que tal!* Me gustaría ordenar lo siguiente:%0a%0a";

        this.order.forEach((item) => {
          url = url + item.name + "%20(cant." + item.quantity + ")%0a";
        });
        this.saveOrder();
        window.open(url, "_blank");
        this.confirmDialog = false;
        this.resetOrder();
      } else {
        this.alertDialog = true;
      }
    },
  },
};
</script>

<style>
.temp-screen {
  padding-top: 15rem !important;
}
</style>
